import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/full-layout/loadable/Loadable';
import HomeAfter from '../views/homeafter';
import Partners from '../views/partners';
import { element } from 'prop-types';
import CTUMapContainer from '../views/events-map/ctu';
import BeforeAfterGallery from '../views/beforeAfterPage';
import NewReports from '../views/newReport';
import NewReportsV2 from '../views/newReportV2';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full-layout/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank-layout/BlankLayout')));
/* ***End Layouts**** */

const Error = Loadable(lazy(() => import('../views/authentication/Error')));
const Login = Loadable(lazy(() => import('../views/authentication/Login')));
const ResetPassword = Loadable(lazy(() => import('../views/authentication/ResetPassword')));

/* ****Pages***** */
const Events = Loadable(lazy(() => import('../views/events')));
const Permissions = Loadable(lazy(() => import('../views/permissions')));
const Roles = Loadable(lazy(() => import('../views/roles')));
const Users = Loadable(lazy(() => import('../views/users')));
const AddEvent = Loadable(lazy(() => import('../views/events/add-event')));
const AddCPSEvent = Loadable(lazy(() => import('../views/events/add-cps-event')));
const PublicEvent = Loadable(lazy(() => import('../views/public-event')));
const MapContainer = Loadable(lazy(() => import('../views/events-map')));
const T1MapContainer = Loadable(lazy(() => import('../views/events-map/theme1')));
const T2MapContainer = Loadable(lazy(() => import('../views/events-map/theme2')));
const T3MapContainer = Loadable(lazy(() => import('../views/events-map/theme3')));
const T4MapContainer = Loadable(lazy(() => import('../views/events-map/theme4')));
const T5MapContainer = Loadable(lazy(() => import('../views/events-map/theme5')));
const DailyBulletin = Loadable(lazy(() => import('../views/daily-bulletin')));
const Home = Loadable(lazy(() => import('../views/home')));
const CloseEvent = Loadable(lazy(() => import('../views/CloseEvent')));
const CloseCPSEvent = Loadable(lazy(() => import('../views/CloseCPSEvent')));
const EventList = Loadable(lazy(() => import('../views/events/event-list')));
const CPSEventList = Loadable(lazy(() => import('../views/events/cps-event-list')));
const EventPage = Loadable(lazy(() => import('../views/events/event-page')));
const EditEvent = Loadable(lazy(() => import('../views/events/edit-event')));
const EditCPSEvent = Loadable(lazy(() => import('../views/events/edit-cps-event')));
const UpdateDailyEvent = Loadable(lazy(() => import('../views/events/update-daily-event')));
const BlackSpotIdentification = Loadable(
  lazy(() => import('../views/black-spots/black-spot-identification'))
);
const BlackSpotList = Loadable(lazy(() => import('../views/black-spots/black-spot-list')));
const ApproveBlackSpot = Loadable(lazy(() => import('../views/black-spots/approve-black-spot')));
const BlackSpots = Loadable(lazy(() => import('../views/black-spots')));
const PartnerSignUp = Loadable(lazy(() => import('../views/authentication/PartnerSignup')));
const AddUser = Loadable(lazy(() => import('../views/users/add-user')));
const ViewEvent = Loadable(lazy(() => import('../views/events/view-event')));
const ViewCPSEvent = Loadable(lazy(() => import('../views/events/view-cps-event')));
const ViewCPSEventPublicSpaces = Loadable(
  lazy(() => import('../views/events/view-cps-event-public-spaces'))
);
const PartnersList = Loadable(lazy(() => import('../views/partnersList')));
const ApproveEvent = Loadable(lazy(() => import('../views/approve-event')));
const ApprovePartner = Loadable(lazy(() => import('../views/approve-partner')));
const CreateSBM = Loadable(lazy(() => import('../views/create-sbm')));
const Reports = Loadable(lazy(() => import('../views/reports')));
const Downloads = Loadable(lazy(() => import('../views/downloads')));
const Sop = Loadable(lazy(() => import('../views/sop')));
const TrainingSchedule = Loadable(lazy(() => import('../views/training-schedule')));
const ViewSBM = Loadable(lazy(() => import('../views/view-sbm')));
const CitizenTestinmonials = Loadable(lazy(() => import('../views/citizen-testimonials')));
const CitizenTestinmonialsList = Loadable(lazy(() => import('../views/citizen-testimonials-list')));
const AdoptCtuList = Loadable(lazy(() => import('../views/adoptCtuList')));
const UploadActionPlan = Loadable(lazy(() => import('../views/uploadActionPlan')));
const ListActions = Loadable(lazy(() => import('../views/listActions')));
const GesiTrainingSchedule = Loadable(lazy(() => import('../views/gesiTrainingSchedule')));
const UlbProfile = Loadable(lazy(() => import('../views/ulbProfile')));
const UploadDailyBulletin = Loadable(lazy(() => import('../views/uploadDailyBulletin')));
const AddTweet = Loadable(lazy(() => import('../views/addTweet')));
const Citizen = Loadable(lazy(() => import('../views/citizen-corner')));
const MyEvents = Loadable(lazy(() => import('../views/myEvents')));
const CampaignDashboard = Loadable(lazy(() => import('../views/campaignDashboard')));
const PartnerReport = Loadable(lazy(() => import('../views/partnerReport')));
const RRRCentersMap = Loadable(lazy(() => import('../views/events-map/rrrcenters')));
const PublicEventPage = Loadable(lazy(() => import('../views/event-page')));
const HGTHGS = Loadable(lazy(() => import('../views/hgthgs')));
const HGTHGSReports = Loadable(lazy(() => import('../views/hgthgsReports')));
const HGTHGS2026 = Loadable(lazy(() => import('../views/hgthgs2026')));
const ReportEvent = Loadable(lazy(() => import('../views/report-event')));
const ReportEventStatus = Loadable(lazy(() => import('../views/events/report-event-status')));
const Selfie = Loadable(lazy(() => import('../views/selfie')));
const UploadSelfie = Loadable(lazy(() => import('../views/uploadSelfie')));
const CTUGuidelines = Loadable(lazy(() => import('../views/ctu-guidelines')));
const Pledge = Loadable(lazy(() => import('../views/pledge')));
const UploadPledge = Loadable(lazy(() => import('../views/uploadPledge')));
// const Certificate = Loadable(lazy(() => import("../views/certificate")));

/* ****Routes***** */

const routes = [
  // { path: '/after-15', element: <Home /> },
  { path: '/', element: <HomeAfter /> },
  { path: '/public-event-page/:id', element: <PublicEventPage /> },
  { path: '/events-map', element: <MapContainer /> },
  { path: '/ctu-map', element: <CTUMapContainer /> },
  // { path: '/rrr-map', element: <RRRCentersMap /> },
  { path: '/theme1-map', element: <T1MapContainer /> },
  { path: '/theme2-map', element: <T2MapContainer /> },
  { path: '/theme3-map', element: <T3MapContainer /> },
  { path: '/theme4-map', element: <T4MapContainer /> },
  { path: '/theme5-map', element: <T5MapContainer /> },
  { path: '/daily-bulletin', element: <DailyBulletin /> },
  { path: '/before-after-ctu-gallery', element: <BeforeAfterGallery /> },
  { path: '/public-events/:id', element: <PublicEvent /> },
  { path: '/event-type-public/:id', element: <ViewCPSEventPublicSpaces /> },
  { path: '/event/:id', element: <EventPage /> },
  { path: '/view-event/:id', element: <ViewEvent /> },
  { path: 'partner-signup', element: <PartnerSignUp /> },
  { path: 'downloads', element: <Downloads /> },
  { path: 'campaign-dashboard', element: <CampaignDashboard /> },
  // { path: 'sop', element: <Sop /> },
  { path: 'partners', element: <Partners /> },
  { path: 'citizen', element: <Citizen /> },
  { path: 'newreports', element: <NewReports /> },
  { path: 'newreports-v2', element: <NewReportsV2 /> },
  { path: '/selfie', element: <Selfie /> },
  { path: '/upload-selfie/:id', element: <UploadSelfie /> },
  // SHS Rollout Picture: Lighting Lamp/Diya -- added 2026-09-14. Same two-step
  // flow as the selfie above, reusing the same two views; only the form_type
  // saved against the public_media document and the on-screen copy differ.
  {
    path: '/diya-lighting',
    element: (
      <Selfie
        formType="DIYA_LIGHTING_FORM"
        uploadPathPrefix="/upload-diya-lighting"
        submitLabelKey="upload_diya_button_text"
        submitLabelFallback="Upload Picture"
        saveErrorMessage="Failed to save your details. Please try again."
      />
    ),
  },
  {
    path: '/upload-diya-lighting/:id',
    element: (
      <UploadSelfie
        uploadTitleKey="upload_diya_title"
        imageNoteKey="diya_image_note"
        disclaimerKey="diya_disclaimer"
        successTitleKey="diya_title"
        successNoteKey="diya_note"
      />
    ),
  },
  { path: '/ctu-guidelines', element: <CTUGuidelines /> },
  { path: '/pledge', element: <Pledge /> },
  { path: '/upload-pledge/:id', element: <UploadPledge /> },
  // { path: "/certificate/:id", element: <Certificate /> },

  // { path: 'training-schedule', element: <TrainingSchedule /> },
  {
    path: '/',
    element: <FullLayout />,
    children: [
      // { path: 'hgt-hgs', element: <HGTHGS /> },
      { path: 'hgt-hgs-2026', element: <HGTHGS2026 /> },
      { path: 'hgt-hgs-reports', element: <HGTHGSReports /> },
      { path: 'partners-list', element: <PartnersList /> },
      { path: 'create-sbm', element: <CreateSBM /> },
      { path: 'view-sbm', element: <ViewSBM /> },
      { path: 'view-citizen-testimonials', element: <CitizenTestinmonialsList /> },
      { path: 'citizen-testimonials', element: <CitizenTestinmonials /> },
      { path: 'add-event', element: <AddEvent /> },
      { path: 'add-cps-event', element: <AddCPSEvent /> },
      { path: 'add-user', element: <AddUser /> },
      { path: 'reports', element: <Reports /> },
      { path: 'upload-action-plan', element: <UploadActionPlan /> },
      { path: 'list-actions', element: <ListActions /> },
      { path: 'gesi-training-schedule', element: <GesiTrainingSchedule /> },
      { path: 'profile', element: <UlbProfile /> },
      { path: 'upload-daily-bulletin', element: <UploadDailyBulletin /> },
      { path: 'add-tweet', element: <AddTweet /> },
      { path: 'approve-event', element: <ApproveEvent /> },
      // { path: 'approve-partner', element: <ApprovePartner /> },
      { path: 'adopt-ctu-list', element: <AdoptCtuList /> },
      { path: 'partner-report', element: <PartnerReport /> },
      { path: 'my-events', element: <MyEvents /> },
      {
        path: 'black-spots',
        element: <BlackSpots />,
        children: [
          { path: '', element: <Navigate to="black-spot-list" /> },
          { path: 'black-spot-list', element: <BlackSpotList /> },
          { path: 'black-spot-identification', element: <BlackSpotIdentification /> },
        ],
      },
      {
        path: 'events',
        element: <Events />,
        children: [
          { path: '', element: <Navigate to="event-list" /> },
          { path: 'event-list', element: <EventList /> },
          { path: 'cps-event-list', element: <CPSEventList /> },
          { path: 'close-event/:id', element: <CloseEvent /> },
          { path: 'close-cps-event/:id', element: <CloseCPSEvent /> },
          { path: 'edit-event/:id', element: <EditEvent /> },
          { path: 'edit-cps-event/:id', element: <EditCPSEvent /> },
          { path: 'view-event/:id', element: <ViewEvent /> },
          { path: 'view-cps-event/:id', element: <ViewCPSEvent /> },
          { path: 'update-daily-event/:id', element: <UpdateDailyEvent /> },
          { path: 'event/:id', element: <EventPage /> },
          { path: 'report-event', element: <ReportEvent /> },
          { path: 'report-event-status', element: <ReportEventStatus /> },
        ],
      },
      { path: 'permissions', element: <Permissions /> },
      { path: 'approve-black-spot', element: <ApproveBlackSpot /> },
      { path: 'roles', element: <Roles /> },
      { path: 'users', element: <Users /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: 'auth',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: 'login', element: <Login /> },
      { path: 'reset-password', element: <ResetPassword /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default routes;
